import React, { Fragment, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
export default function A2PortfolioTechStack({
  slides,
  headingColor,
  Color,
  strokeTextColor,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <Fragment>
      <div className="horizontal-padding pb-5">
        <div className="row">
          <div
            className={`col-lg-5 col-md-12 col-12 portfolio-technical-specifications ${
              Color ? Color : ""
            }`}
          >
            <h2 className={`a2-font-3 ${headingColor ? headingColor : ""}`}>
              Technical Specifications
            </h2>
          </div>
          <div className="col-lg-7 col-md-12 col-12 position-relative">
            <Swiper
              direction="vertical"
              slidesPerView={1}
              loop={true}
              allowTouchMove={false} // disable touch swipe on slides
              touchRatio={0} // extra safeguard
              simulateTouch={false} // disable mouse drag
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              speed={1500}
              modules={[Autoplay]}
              className="vertical-swiper"
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            >
              {slides.map((slide, index) => (
                <SwiperSlide
                  key={slide.title}
                  className={activeIndex === index ? "slide-animate" : ""}
                >
                  <span
                    className={`portfolio-stroke-text ${
                      strokeTextColor ? strokeTextColor : ""
                    } ${slide.title
                      ?.replace("& ", "")
                      ?.replaceAll(" ", "-")
                      .toLowerCase()}`}
                  >
                    {slide.title}
                  </span>
                  <div
                    style={{
                      position: "absolute",
                      top: "10%",
                      placeSelf: "anchor-center",
                      textAlign: "center",
                    }}
                  >
                    {slide.logos.map((item, i) => (
                      <img
                        key={i + item}
                        src={`/images/Technology/${item.trim()}`}
                        alt={item}
                        height={"50px"}
                        className="mx-md-5 mx-2"
                      />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
